import React from "react";
import { Card } from "rhombus-react";
import { Field } from "redux-form";
import { ASSET_TYPES } from "utils/constants";
import { formatBytes } from "utils/common";
import { SNAPCHAT_CAROUSEL_DISCOVERY_CONSTRAINTS } from "social/validators/snapchat";
import DynamicInput from "social/DynamicInput";
import DynamicAssetSelect from "social/DynamicAssetSelect";

import './SnapchatCarouselDiscoverTile.css';

const {
	MAX_LENGTH_HEADLINE,
	BACKGROUND_ACCEPT,
	BACKGROUND_MAX_BYTES,
	BACKGROUND_DIMENSIONS,
	LOGO_ACCEPT,
	LOGO_DIMENSTIONS,
	LOGO_MAX_BYTES,
} = SNAPCHAT_CAROUSEL_DISCOVERY_CONSTRAINTS;

export const SNAPCHAT_CAROUSEL_DISCOVER_TILE_FIELDS = {
	discoveryHeadline: {
		name: 'discoveryHeadline',
		label: "Headline",
		className: "full-width cypress-headline",
		defaultDynVarName: "headline",
		placeholder: "Enter a short headline",
		required: true,
		component: DynamicInput,
		charMax: MAX_LENGTH_HEADLINE,
	},
	discoveryBackgroundImage: {
		name: 'discoveryBackgroundImage',
		label: 'Background',
		component: DynamicAssetSelect,
		assetType: ASSET_TYPES.IMAGE,
		defaultDynVarName: "background_image",
		accept: BACKGROUND_ACCEPT,
		className: "half-width",
		required: true,
		tip: {
			direction: "top",
			description: `
      Please account for a 175 px 'buffer zone' at the top of the image.<br />
      This is to ensure your logo does not conflict with any important<br />
      image elements on the vertical tile.
			`,
			html: true,
		},
		requirements: [
			{
				name: "File Size",
				description: `Up to ${formatBytes(BACKGROUND_MAX_BYTES)}`,
			},
			{
				name: "File Types",
				description: BACKGROUND_ACCEPT,
			},
			{
				name: "Dimensions",
				description: `${BACKGROUND_DIMENSIONS.width}x${BACKGROUND_DIMENSIONS.height} pixels`,
			},
		],
	},
	discoveryLogoImage: {
		name: 'discoveryLogoImage',
		label: 'Logo',
		component: DynamicAssetSelect,
		assetType: ASSET_TYPES.IMAGE,
		defaultDynVarName: "logo_image",
		accept: LOGO_ACCEPT,
		className: "half-width",
		required: true,
		requirements: [
			{
				name: "File Size",
				description: `Up to ${formatBytes(LOGO_MAX_BYTES)}`,
			},
			{
				name: "File Types",
				description: `${LOGO_ACCEPT} (transparent)`,
			},
			{
				name: "Dimensions",
				description: `${LOGO_DIMENSTIONS.width}x${LOGO_DIMENSTIONS.height} pixels`,
			},
		],
	},
};

export default function SnapchatCarouselDiscoverTile(props){
	const { libraryId, navigationActions, isViewOnly } = props;

	const $fields = Object.values(SNAPCHAT_CAROUSEL_DISCOVER_TILE_FIELDS).map((fieldProps)=> {
		const extraProps = {};
		if (fieldProps.name === 'discoveryBackgroundImage' || fieldProps.name === 'discoveryLogoImage') {
			extraProps.libraryId = libraryId;
			extraProps.navigationActions = navigationActions;
		}
		extraProps.disabled = isViewOnly;
		if (extraProps.disabled && fieldProps.placeholder) {
			// We set this on extraProps, because we don't want to mutate the fieldProps consts
			extraProps.placeholder = '';
		}
		return (
			<Field
				key={fieldProps.name}
				{...fieldProps}
				{...extraProps}
			/>
		);
	});

	return (
		<Card
			className="carousel-main-content discover-tile"
			header="Discover Tile"
			isCollapsable
			isVisible
		>
			<div className="carousel-modal-content form-container">
				<div className="fields">
					{$fields}
				</div>
			</div>
		</Card>
	);
}
